import { render, staticRenderFns } from "./OrderShareChart.vue?vue&type=template&id=40406be0"
import script from "./OrderShareChart.vue?vue&type=script&lang=js"
export * from "./OrderShareChart.vue?vue&type=script&lang=js"
import style0 from "./OrderShareChart.vue?vue&type=style&index=0&id=40406be0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports